"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownBar = void 0;
var preact_1 = require("preact");
var styles = __importStar(require("./dropdown-bar.component.scss"));
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var dropdown_bar_item_1 = require("../dropdown-bar-item/dropdown-bar-item");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var Scrollable = kaltura_player_js_1.ui.Components.Scrollable;
var PADDING_FROM_BOTTOM = 16;
var DropdownBar = /** @class */ (function (_super) {
    __extends(DropdownBar, _super);
    function DropdownBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownBar.prototype.calculateMaxHeight = function () {
        var playerHeight = this.props.player.getVideoElement().clientHeight;
        // taking the topBarMaxHeight from the window because ui-managers repo is not working with updated ui version
        // once aligning ui-managers with latest ui we can import ui and get the topBarMaxHeight from there, instead of window
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return playerHeight - Number(window.KalturaPlayer.ui.style.topBarMaxHeight) - PADDING_FROM_BOTTOM;
    };
    DropdownBar.prototype.render = function () {
        var _this = this;
        var maxHeightStyle = this.calculateMaxHeight();
        var dropDownProps = {
            className: styles.moreDropdown,
            role: 'menu',
            ariaExpanded: true,
            style: { maxHeight: "".concat(maxHeightStyle, "px") }
        };
        var controlsLength = this.props.controls.length;
        return ((0, preact_1.h)("div", __assign({}, dropDownProps),
            (0, preact_1.h)(Scrollable, { isVertical: true }, this.props.controls.map(function (_a, index) {
                var id = _a.id, displayName = _a.displayName, label = _a.label, ariaLabel = _a.ariaLabel, svgIcon = _a.svgIcon, onClick = _a.onClick, isDisabled = _a.isDisabled;
                var icon = typeof svgIcon === 'function' ? svgIcon() : svgIcon;
                var text = typeof label === 'function' ? label() : label;
                var ariaLabelText = typeof ariaLabel === 'function' ? ariaLabel() : ariaLabel;
                var isDisabledValue = typeof isDisabled === 'function' ? isDisabled() : isDisabled;
                return ((0, preact_1.h)(dropdown_bar_item_1.DropdownBarItem, { key: id, displayName: displayName, text: text, ariaLabel: ariaLabelText, isDisabled: isDisabledValue, icon: icon, onClick: onClick, onDropdownClick: _this.props.onDropdownClick, tooltipPosition: index === controlsLength - 1 ? 'top' : 'bottom' }));
            }))));
    };
    return DropdownBar;
}(preact_1.Component));
exports.DropdownBar = DropdownBar;
